// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"79ef8a5e","952":"bcafdfb0"}[chunkId] + ".chunk.js";
};